import(/* webpackMode: "eager", webpackExports: ["CampusEmbeddedWorkspace"] */ "/vercel/path0/app/campus/CampusEmbeddedWorkspace.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CampusMapPreview"] */ "/vercel/path0/app/campus/CampusMapPreview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CampusOverview"] */ "/vercel/path0/app/campus/CampusOverview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CampusTransitStops"] */ "/vercel/path0/app/campus/CampusTransitStops.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
